import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    sectionContent: {
      margin: '0 0 32px',
      flex: 1,
    },
  });
